export default __webpack_public_path__ + "static/media/empty-star.5ff9c175.svg";